<template>
    <div v-if="records && records.length" class="other-company-records bg-info-pale text-info-pale-dark rounded mb-2">
        <a
            href
            role="button"
            class="collapse-trigger d-flex align-items-center px-1 py-hf text-info-pale-dark no-underline"
            :class="{'is-expanded': expanded}"
            @click.prevent="$emit('toggle_expand')"
        >
            <collapse-toggle-button />
            <span class="ml-hf">
                This employee has records at <strong>{{ countLabel }}</strong>.
            </span>
        </a>

        <div v-show="expanded" class="px-2 pb-2">
            <div class="form-row align-items-baseline py-qt">
                <div class="col-6"><h5 class="theading m-0 text-info-pale-dark">Company</h5></div>
                <div class="col-3"><h5 class="theading m-0 text-info-pale-dark">EE ID</h5></div>
                <div class="col-3"><h5 class="theading m-0 text-info-pale-dark">Status</h5></div>
            </div>
            <div
                v-for="record in records"
                :key="record.id"
                class="form-row align-items-baseline py-qt"
            >
                <div class="col-12 col-sm-6">
                    <a href @click.prevent="$emit('switch-employee', { employee_id: record.id })">
                        <i class="fas fa-fw fa-exchange-alt mr-qt"></i>
                        {{ record.company.name || record.company.company_code }}
                    </a>
                </div>
                <div class="col-12 col-sm-3">
                    {{ record.employee_number }}
                </div>
                <div class="col-12 col-sm-3">
                    <span v-if="record.employment_status == 'Active'">{{ record.employment_status }}</span>
                    <span v-else class="text-danger-dark text-italic">{{ record.employment_status }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.other-company-records {
    .collapse-trigger.no-underline {
        &,
        &:hover,
        &:focus,
        &:active {
            text-decoration: none;
        }
    }
}
</style>

<script>
import CollapseToggleButton from '@/components/CollapseToggleButton'

export default {
    components: { CollapseToggleButton },
    props: {
        records: { type: Array, default: () => [] },
        expanded: { type: Boolean, default: false },
    },
    emits: ['toggle_expand', 'switch-employee'],
    computed: {
        countLabel() {
            const n = this.records.length
            return n === 1 ? '1 other company' : `${n} other companies`
        },
    },
}
</script>
